/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

export const LOADING_ENGINE = 'LOADING_ENGINE'
export const LOADING_INFO = 'LOADING_INFO'
export const SET_ENGINE_STATUS = 'SET_ENGINE_STATUS'
export const UPDATE_ENGINE_INFO = 'UPDATE_ENGINE_INFO'

export default {
  LOADING_ENGINE,
  LOADING_INFO,
  SET_ENGINE_STATUS,
  UPDATE_ENGINE_INFO,
}
